/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Scale } from '../../UNSAFE_Chart';
import { DataCursorStyle } from './DataCursor.types';

export function getDataCursorCoords(
  xScale: Scale,
  x: number,
  plotAreaSpace: { x: number; y: number; height: number; width: number },
  isHoriz: boolean,
  dataCursorStyle?: DataCursorStyle
) {
  const lineColor = dataCursorStyle?.lineColor;
  const lineStyle = dataCursorStyle?.lineStyle;
  const y1 = isHoriz ? xScale.transform(x) : plotAreaSpace.y + plotAreaSpace.height;
  const x1 = isHoriz ? plotAreaSpace.x : xScale.transform(x);

  const y2 = isHoriz ? xScale.transform(x) : plotAreaSpace.y;
  const x2 = isHoriz ? plotAreaSpace.x + plotAreaSpace.width : xScale.transform(x);

  const lineWidth = dataCursorStyle?.lineWidth || 1;
  return {
    mainLineProps: {
      x1,
      y1,
      x2,
      y2,
      style: {
        stroke: lineColor,
        strokeDashArray: lineStyle === 'dotted' ? 3 : lineStyle === 'dashed' ? 6 : undefined,
        strokeWidth: lineWidth
      }
    },
    contrastLineProps: {
      x1: isHoriz ? x1 : x1 + lineWidth,
      y1: isHoriz ? y1 + lineWidth : y1,
      x2: isHoriz ? x2 : x2 + lineWidth,
      y2: isHoriz ? y2 + lineWidth : y2
    }
  };
}
